<script setup lang="ts">
    interface Props{
        type?:"error"
    }

    const props = defineProps<Props>()

    const propsClass = computed(()=>{
        const list =[]
        if(props.type){
            list.push(props.type)
        }
        return list
    })
</script>

<template>
    <span :class="propsClass" >
        <slot></slot>
    </span>
</template>
<style scoped>
.error{
    @apply text-red-600 font-bold text-sm;
}
</style>